import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useSummary} from 'context/summary';
import {useChekinSDK} from 'context/ChekinSDK';
import {GuestTokenStorageHandler} from '@guestapp/sdk';

type Props = {
  enabled?: boolean;
};
function useFetchUser({enabled}: Props = {enabled: true}) {
  const {getMe} = useChekinSDK();
  const {isInstantCheckInEnabled} = useSummary();
  const guestToken = GuestTokenStorageHandler.getToken();

  return useQuery([QUERY_CACHE_KEYS.user, guestToken], () => getMe(), {
    enabled: Boolean(enabled && isInstantCheckInEnabled && guestToken),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export {useFetchUser};
